<template>
  <div class="share-tray-block container my-3">
    <h5 class="share-tray-header text-center ">
      {{ $resourceString["virtualtray.Sharetray.Header"] }}
    </h5>
    <button
      type="button"
      class="wf-modal-button-close btn button-full"
      @click="hideModal('share-tray')"
    >
      <span
        aria-label="Close modal"
        class="png-icon png-icon-icons-symbols--k-txtclose"
      >
      </span>
    </button>
    <div class="my-3">
      <label for="sharable_link">
        {{ $resourceString["common.Sharetray.Link.Label"] }}
      </label>
      <div class="mb-2">
        <input
          type="text"
          class="form-control"
          id="sharable_link"
          v-model="trayUrl"
          aria-describedby="basic-addon3"
          disabled
        />
      </div>

      <label for="invite_people">
        {{ $resourceString["virtualtray.Sharetray.Email.Label"] }}*
      </label>

      <div class="mb-2 d-flex justify-content-between align-items-center">
        <div class="input-group">
        <input
          type="text"
          class="form-control"
          id="invite_people"
          v-model="newEmail"
          placeholder="Enter email(s)"
          @keydown.enter="addEmail"
        />
        <div class="input-group-append input-container">
          <button class=" btn-primary small-button " :class="newEmail.length<=0?'disabled':''" @click.prevent="addEmail"
          :disabled="newEmail.length == 0"
          >+

          </button>
        </div>
      </div>
        </div>

        <div
          class="wf-current-refinements-group"
          v-for="(email, index) in emails"
          :key="index"
        >
          <a
            class="btn btn-white shadow-sm mx-1 my-1 bg-dark text-light text-transform-none"
          >
            {{ email }}

            <span
              class="png-icon png-icon-icons-glyph--k-close"
              style="width: 10px;height: 16px;"
              @click="removeEmail(index)"
              >&times;</span
            ></a
          >
        </div>
        <p class="text-danger font-16">
          {{
            validationError.registeredEmail
              ? $resourceString["virtualtray.Sharetray.Email.Role.Error"]
              : validationError.invitePeople
              ? $resourceString["virtualtray.Sharetray.Email.Required.Error"]
              : validationError.validEmail
              ? $resourceString["virtualtray.Sharetray.Email.ValidEmail.Error"]
              : ""
          }}
        </p>
      <label for="email_subject">
        {{ $resourceString["virtualtray.Sharetray.Subject.Label"] }}*
      </label>
      <div class=" mb-3">
        <input
          type="text"
          class="form-control"
          id="email_subject"
          placeholder="Email Subject"
          v-model="emailSubject"
        />
        <p class="text-danger font-16" v-if="validationError.emailSubject">
          {{ $resourceString["virtualtray.Sharetray.Subject.Error"] }}
        </p>
      </div>
      <label for="tray-description">
        {{ $resourceString["common.Sharetray.EmailNote.Label"] }} {{ $resourceString["contentWizard.Label.Field.Optional"] }}
      </label>
      <div class="input-group mb-4">
        <textarea
          class="form-control"
          id="tray-description"
          v-model="emailNote"
          aria-label="With textarea"
          placeholder="Email Note..."
        ></textarea>
      </div>
      <div class="mt-2 float-right">
        <button class="btn btn-outline-primary" @click="handleModalClose">
          {{ $resourceString["virtualtray.Savetray.Cancel.Button"] }}
        </button>
        <button class="btn btn-primary" @click="shareTrayItem">
          {{ $resourceString["virtualtray.Sharetray.Share.Button"] }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["userEmail"],
  data() {
    return {
      emails: [],
      newEmail: "",
      isValid: false,

      trayUrl: "",
      trayId: "",
      emailSubject: null,
      emailNote: null,
      invitePeople: null,
      validationError: {
        emailSubject: false,
        invitePeople: false,
        registeredEmail: false,
        validEmail: false
      }
    };
  },
  computed: {
    ...mapGetters({
      trayOrders: "virtualTray/trayOrders",
      shareTrayId: "myTray/getShareTrayId",
      getUserInfoEmail: "myTray/getUserInfoEmail",
      getUserEmaiFromVTpage: "myTray/getUserEmaiFromVTpage"
    })
  },
  created() {
    const currentUrl = window.location.href;
    let urlParts = currentUrl.split("/");
    this.trayId = urlParts[urlParts.length - 1];
    if (urlParts.includes("EditTray") || urlParts.includes("edittray")) {
      this.trayId = urlParts[urlParts.length - 1];
    } else {
      this.trayId = null;
    }

    if (this.trayId) {
      this.trayUrl = new URL(window.location.href);
    } else {
      let newUrl = new URL(window.location.href);
      this.trayUrl =
        newUrl.origin + `/virtualtray/edittray/${this.shareTrayId}`;
    }
  },
  methods: {
    ...mapActions({
      saveTray: "myTray/saveTray",
      shareTray: "myTray/shareTray",
      createShareTrayApi: "myTray/createShareTrayApi",
      resourceString: "myTray/resourceString"
    }),
    addEmail() {
      if (this.newEmail) {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        let boolVaule = emailPattern.test(this.newEmail);
        if (!boolVaule) {
          this.validationError.registeredEmail = false;
          this.validationError.invitePeople = false;
          return (this.validationError.validEmail = true);
        }
        if (
          this.getUserInfoEmail === this.newEmail ||
          this.userEmail === this.newEmail
        ) {
          this.validationError.validEmail = false;
          this.validationError.invitePeople = false;
          return (this.validationError.registeredEmail = true);
        }
        if (boolVaule) {
          this.emails.push(this.newEmail);
          this.newEmail = "";
          this.isValid = false;
          this.validationError.registeredEmail = false;
          this.validationError.validEmail = false;
          this.validationError.invitePeople = false;
        }
      }
    },

    removeEmail(index) {
      this.emails.splice(index, 1);
    },
    async shareTrayItem() {
      this.validationError.emailSubject = false;
      this.validationError.invitePeople = false;
      this.validationError.registeredEmail = false;
      this.validationError.validEmail = false;
      let validationStatus = true;
      if (!this.emailSubject) {
        this.validationError.emailSubject = true;
        validationStatus = false;
      }
      if (this.emails.length == 0 || this.isValid) {
        this.validationError.invitePeople = true;
        validationStatus = false;
      }
      if (validationStatus) {
        let createShareTrayData = {
          boardId: this.shareTrayId ? this.shareTrayId : this.trayId,
          emails: this.emails,
          role: 0,
          isAdmin: false
        };
        if(await this.createShareTrayApi(createShareTrayData)){
          let data = {
            EmailNote: this.emailNote,
            Recipients: this.emails,
            boardId: this.shareTrayId ? this.shareTrayId : this.trayId,
            subject: this.emailSubject,
            isProject : false
          };
          await this.resourceString(
            this.$resourceString["virtualtray.Tray.Shared.Msg"]
          );
          await this.shareTray(data);
          this.hideModal("share-tray");
        }
      }
    },
    hideModal(name) {
      this.$modal.hide(name + "-modal");
    },
    handleModalClose() {
      this.hideModal("share-tray");
    }
  },
};
</script>

<style>
.small-button {
  width: 27px;
  height: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 8px;
  z-index:99;
}

#invite_people {
  flex: 1;
}
.input-container {
  display: flex;
  align-items: center;
  position: relative;
}
.disabled{
  background-color: #ccc !important;
  color: #666 !important;
  cursor: not-allowed;
}

</style>
